import * as z from 'zod'
import { useLogsStore } from '@/store/logs'

/** RAW SETTINGS, THESE ARE ASSEMBLED INTO THE ACTUAL DISPLAY MODE SETTINGS LATER **/

// Whether to Enable Pen State Chart Reduction
const enablePenStateIncidentChartReduction = z.boolean().default(true).optional()

//Which Dashboard to Show as the default dashboard. Can be either one of the inbuilt dashboards or a senator dashboard
const startDashboard = z.string().max(30).optional().default('simplified-overview')

//Whether to Use Seasonal Styling (Special Backgrounds etc.)
const useSeasonalStyling = z.boolean().default(true).optional()

/** FULLY ASSEMBLED DISPLAY MODE SCHEMA **/
export const displayModeSchema = z.object({
  enablePenStateIncidentChartReduction,
  startDashboard,
  useSeasonalStyling,
})

export function parseDisplayModeAndRemoveIllegalProperties(displayMode: unknown, globalUniqueIdentifier: string) {
  const result = displayModeSchema.safeParse(displayMode)

  if (result.success) {
    return result.data
  }
  result.error.issues.forEach(error => {
    useLogsStore().addLogEntry({
      message: `Illegal property at ${error.path.join('.')}: ${error.message}`,
      level: 'ERROR',
      tag: 'displayModeSchema',
      globalUniqueIdentifier,
    })
  })

  const cleanResult = displayModeSchema.safeParse(displayMode)

  if (!cleanResult.success) {
    throw new Error(`Critical validation failure: ${cleanResult.error.message}`)
  }

  return cleanResult.data
}
